import { Type } from "class-transformer";
import { StudioProjectAttributes } from "imagica-corekit/dist/base/project/domain/StudioProjectAttributes";

export class DomainCheckResponse {
  public detail: string[] = [];

  @Type(() => Instruction)
  public instructions?: Instruction;
}
export class Instruction {
  public description: string = "";

  @Type(() => InstructionItem)
  public instructions: Array<InstructionItem> = [];

  @Type(() => Link)
  public link?: Link;
}
export class InstructionItem {
  public Type: string = "";
  public Name: string = "";
  public Value: string = "";
  public Status: string = "";
  get isSuccess(): boolean {
    return this.Status.toLowerCase() === "success";
  }
  equral(to: InstructionItem) {
    return this.Name === to.Name && this.Value === to.Value && this.Type === to.Type;
  }
}
class Link {
  public value: string = "";
  public text: string = "";
}
